import React, { useCallback } from "react";
import { registerView, View, ViewComponent } from "@frui.ts/views";
import { observer, Observer } from "mobx-react-lite";
import { Col, Form, Jumbotron, Row } from "react-bootstrap";
import ContactMultiEshopViewModel from "../../viewModels/multiEshop/contactMultiEshopViewModel";
import ErrorCard from "../common/error/errorCard";
import Status from "./components/status";
import Button from "@edaz/edazkit/Button";
import { IconType } from "@edaz/edazkit/Icon";

const contactMultiEshopView: ViewComponent<ContactMultiEshopViewModel> = observer(({ vm }) => {
  const error = (code: string) => vm.localizationService.translateGeneral(`errors.${code}`);
  const formRef = useCallback(node => {
    if (node !== null) {
      vm.formElement = node;
    }
  }, []);

  return (
    <Form ref={formRef}>
      <Row id="multiEshop">
        <Col sm={12} lg={8}>
          <Jumbotron className="px-lg-10 py-lg-7 p-s-0 multi-eshop">
            <Status current={3} statusSteps={vm.statusNavigation} translate={vm.translate} />
            {vm.errorMessage && <ErrorCard message={error(vm.errorMessage)} sticky={true} />}
            <fieldset>
              <Row className="mb-4">
                <Col sm={6} xl={6} className="d-flex justify-content-start align-items-center mb-3">
                  <h3 className="mb-0">{vm.translate("contact")}</h3>
                </Col>
                <Col sm={6} xl={6} className="d-flex justify-content-end align-items-center mb-3">
                  <Button
                    type="button"
                    variant="light-danger"
                    size="sm"
                    style={{ textTransform: "none" }}
                    onClick={vm.resetChargeOrder}
                    iconLeftVariant="light-danger"
                    iconLeft={IconType.Cross}>
                    {vm.translate("cancel")}
                  </Button>
                </Col>
              </Row>
              <Observer>{() => <View vm={vm.contactViewModel} />}</Observer>
              <Observer>{() => <View vm={vm.gdprInfoViewModel} />}</Observer>
            </fieldset>
          </Jumbotron>
        </Col>
        <Col sm={12} lg={4}>
          <Observer>{() => <View vm={vm.summaryViewModel} />}</Observer>
        </Col>
      </Row>
    </Form>
  );
});

registerView(contactMultiEshopView, ContactMultiEshopViewModel);
